import {MajorGameEventTemplateAnimationSetModel} from "../../templates/major-game-event-template-animation-set-model";

export class BasePenaltyMissedAnimationSetModel extends MajorGameEventTemplateAnimationSetModel {}